/* eslint-disable react/prop-types */
import {Component} from 'react';
import {withRouter} from "react-router-dom";

class ScrollToTop extends Component {

    componentDidUpdate(prevProps) {

        // Don't scrolltop on /inform/research (Charts) pages
        if (this.props.location && prevProps.location && this.props.location.pathname.startsWith('/inform/research') && prevProps.location.pathname.startsWith('/inform/research')) {
            return;
        }

        // Don't scrolltop on /index-center/ (IndexCharts) pages
        if (this.props.location && prevProps.location && this.props.location.pathname.startsWith('/index') && prevProps.location.pathname.startsWith('/index')) {
            return;
        }

        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        return this.props.children
    }

}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./frontend/ScrollTop.jsx